<div>
    <p-speedDial [model]="items" [direction]="direction" transitionDelay="80" buttonClassName="p-button-outlined">
        <ng-template pTemplate="button">
            <div class="w-8 h-8">
                <img alt="dropdown icon" [src]="'/assets/flag/'+activeLang+'-flag.svg'">
            </div>
        </ng-template>
    </p-speedDial>
</div>